import { render, staticRenderFns } from "./DashboardWidgetROI.vue?vue&type=template&id=70fa29ad&"
import script from "./DashboardWidgetROI.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetROI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports